import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, withKeys as _withKeys, vModelText as _vModelText, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "blue_box _full" }
const _hoisted_3 = { class: "sch_condition_wrap" }
const _hoisted_4 = { class: "left _column _flex" }
const _hoisted_5 = { class: "radio_wrap sch_list" }
const _hoisted_6 = { for: "chk1" }
const _hoisted_7 = { for: "chk2" }
const _hoisted_8 = { class: "_flex _align_bottom _multi" }
const _hoisted_9 = { class: "select_date_wrap" }
const _hoisted_10 = { class: "select_date" }
const _hoisted_11 = { class: "select_date" }
const _hoisted_12 = {
  key: 0,
  class: "search_wrap"
}
const _hoisted_13 = { class: "select_tab_box_wrap" }
const _hoisted_14 = { class: "select_tab_box _130" }
const _hoisted_15 = { class: "tab_option" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "search_wrap" }
const _hoisted_18 = {
  key: 0,
  class: "right _align_bottom _flex"
}
const _hoisted_19 = { type: "button" }
const _hoisted_20 = {
  key: 1,
  class: "right _align_bottom _flex"
}
const _hoisted_21 = { type: "button" }
const _hoisted_22 = {
  key: 0,
  class: "common_table custom_scroll medium"
}
const _hoisted_23 = { class: "checkbox_wrap cnt p_5 checkbox_wrap2" }
const _hoisted_24 = { class: "checkbox_wrap cnt p_5 checkbox_wrap2" }
const _hoisted_25 = ["for"]
const _hoisted_26 = ["id", "value"]
const _hoisted_27 = { class: "text_center" }
const _hoisted_28 = { class: "ellipsis_1 underline" }
const _hoisted_29 = ["href"]
const _hoisted_30 = { class: "p_0 cnt" }
const _hoisted_31 = { class: "cnt" }
const _hoisted_32 = { class: "cnt" }
const _hoisted_33 = { class: "cnt" }
const _hoisted_34 = { class: "p_0 cnt" }
const _hoisted_35 = { class: "p_0 cnt" }
const _hoisted_36 = { class: "cnt" }
const _hoisted_37 = { class: "cnt p_5" }
const _hoisted_38 = { class: "cnt" }
const _hoisted_39 = { class: "cnt p_5" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { class: "cnt p_5" }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = { class: "cnt p_5" }
const _hoisted_44 = ["onClick"]
const _hoisted_45 = { class: "cnt p_5" }
const _hoisted_46 = ["onClick"]
const _hoisted_47 = { key: 1 }
const _hoisted_48 = {
  key: 1,
  class: "common_table custom_scroll medium"
}
const _hoisted_49 = { class: "checkbox_wrap cnt p_5 checkbox_wrap2" }
const _hoisted_50 = { class: "checkbox_wrap cnt p_5 checkbox_wrap2" }
const _hoisted_51 = ["for"]
const _hoisted_52 = ["id", "value"]
const _hoisted_53 = { class: "text_center" }
const _hoisted_54 = { class: "ellipsis_1 underline" }
const _hoisted_55 = ["href"]
const _hoisted_56 = { class: "text_center" }
const _hoisted_57 = { class: "text_center" }
const _hoisted_58 = { class: "cnt" }
const _hoisted_59 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Left = _resolveComponent("Left")!
  const _component_PageBtn = _resolveComponent("PageBtn")!
  const _component_ModalDefault = _resolveComponent("ModalDefault")!
  const _component_FormListModal = _resolveComponent("FormListModal")!
  const _component_ActivityModal = _resolveComponent("ActivityModal")!
  const _component_ActivityStateModal = _resolveComponent("ActivityStateModal")!
  const _component_ActivityRecruitModal = _resolveComponent("ActivityRecruitModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createVNode(_component_Left),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[69] || (_cache[69] = _createElementVNode("div", { class: "box_tit _flex" }, [
          _createElementVNode("h2", null, "시민활동관리")
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("label", _hoisted_6, [
                _withDirectives(_createElementVNode("input", {
                  id: "chk1",
                  name: "cate",
                  type: "radio",
                  value: 1,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.state.typeState) = $event)),
                  onChange: _cache[1] || (_cache[1] = ($event: any) => {
                                    $setup.state.page = 1;
                                    $setup.getList();
                                })
                }, null, 544), [
                  [_vModelRadio, $setup.state.typeState]
                ]),
                _cache[38] || (_cache[38] = _createElementVNode("em", null, null, -1)),
                _cache[39] || (_cache[39] = _createElementVNode("span", null, "반성매매 시민활동", -1))
              ]),
              _createElementVNode("label", _hoisted_7, [
                _withDirectives(_createElementVNode("input", {
                  id: "chk2",
                  name: "cate",
                  type: "radio",
                  value: 3,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.state.typeState) = $event)),
                  onChange: _cache[3] || (_cache[3] = ($event: any) => {
                                    $setup.state.page = 1;
                                    $setup.getList();
                                })
                }, null, 544), [
                  [_vModelRadio, $setup.state.typeState]
                ]),
                _cache[40] || (_cache[40] = _createElementVNode("em", null, null, -1)),
                _cache[41] || (_cache[41] = _createElementVNode("span", null, "시민활동 제안", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    onKeydown: _cache[4] || (_cache[4] = _withKeys(
//@ts-ignore
(...args) => ($setup.searchDate && $setup.searchDate(...args)), ["enter"])),
                    name: "",
                    id: "",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.form_state.startDate) = $event)),
                    onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => ($setup.getList && $setup.getList(...args)))
                  }, null, 544), [
                    [_vModelText, $setup.form_state.startDate]
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _withDirectives(_createElementVNode("input", {
                    style: {"margin-left":"5px"},
                    type: "date",
                    onKeydown: _cache[7] || (_cache[7] = _withKeys(
//@ts-ignore
(...args) => ($setup.searchDate && $setup.searchDate(...args)), ["enter"])),
                    name: "",
                    id: "",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.form_state.endDate) = $event)),
                    onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => ($setup.getList && $setup.getList(...args)))
                  }, null, 544), [
                    [_vModelText, $setup.form_state.endDate]
                  ])
                ])
              ]),
              ($setup.state.typeState == 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      placeholder: "제목을 입력하세요.",
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.state.searchText) = $event)),
                      onKeyup: _cache[11] || (_cache[11] = _withKeys(
//@ts-ignore
(...args) => ($setup.getList && $setup.getList(...args)), ["enter"]))
                    }, null, 544), [
                      [_vModelText, $setup.state.searchText]
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "search_btn icon_wrap",
                      onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => ($setup.getList && $setup.getList(...args)))
                    }, [...(_cache[42] || (_cache[42] = [
                      _createElementVNode("img", {
                        src: "img/search_btn.png",
                        alt: ""
                      }, null, -1)
                    ]))])
                  ]))
                : _createCommentVNode("", true),
              ($setup.state.typeState == 3)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["selected_tab", [$setup.state.isShowOfferActive ? 'active' : '']]),
                          onClick: _cache[13] || (_cache[13] = ($event: any) => ($setup.state.isShowOfferActive = !$setup.state.isShowOfferActive))
                        }, [
                          _createElementVNode("span", null, _toDisplayString($setup.state.searchTypeTxt), 1)
                        ], 2),
                        _createElementVNode("div", _hoisted_15, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.offer_active_list, (item) => {
                            return (_openBlock(), _createElementBlock("button", {
                              onClick: ($event: any) => {
                                                $setup.state.searchType = item.key;
                                                $setup.state.searchTypeTxt = item.value;
                                                $setup.state.isShowOfferActive = false;
                                                $setup.state.page = 1;
                                                $setup.getList();
                                            }
                            }, _toDisplayString(item.value), 9, _hoisted_16))
                          }), 256))
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.state.searchText) = $event)),
                        onKeyup: _cache[15] || (_cache[15] = _withKeys(($event: any) => {
                                        $setup.state.page = 1;
                                        $setup.getList();
                                    }, ["enter"])),
                        placeholder: "검색어를 입력하세요."
                      }, null, 544), [
                        [_vModelText, $setup.state.searchText]
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "search_btn icon_wrap",
                        onClick: _cache[16] || (_cache[16] = ($event: any) => {
                                        $setup.state.page = 1;
                                        $setup.getList();
                                    })
                      }, [...(_cache[43] || (_cache[43] = [
                        _createElementVNode("img", {
                          src: "img/search_btn.png",
                          alt: ""
                        }, null, -1)
                      ]))])
                    ])
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ]),
          ($setup.state.typeState === 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("button", {
                  type: "button",
                  class: "default_btn _blue",
                  onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => ($setup.addActivity && $setup.addActivity(...args)))
                }, "반성매매 시민활동 등록"),
                _createElementVNode("button", {
                  type: "button",
                  class: "default_btn _gray",
                  onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => ($setup.isDelete && $setup.isDelete(...args)))
                }, "삭제"),
                _createElementVNode("button", _hoisted_19, [
                  _createElementVNode("img", {
                    src: "img/excel_icon.png",
                    alt: " 엑셀 다운로드",
                    onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => ($setup.downloadFile && $setup.downloadFile(...args)))
                  })
                ])
              ]))
            : ($setup.state.typeState === 3)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "default_btn _gray",
                    onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => ($setup.isDelete && $setup.isDelete(...args)))
                  }, "삭제"),
                  _createElementVNode("button", _hoisted_21, [
                    _createElementVNode("img", {
                      src: "img/excel_icon.png",
                      alt: " 엑셀 다운로드",
                      onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => ($setup.downloadFile && $setup.downloadFile(...args)))
                    })
                  ])
                ]))
              : _createCommentVNode("", true)
        ]),
        ($setup.state.typeState == 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _createElementVNode("table", null, [
                _cache[60] || (_cache[60] = _createElementVNode("colgroup", null, [
                  _createElementVNode("col", { style: {"width":"40px"} }),
                  _createElementVNode("col", { style: {"width":"100px"} }),
                  _createElementVNode("col"),
                  _createElementVNode("col", { style: {"width":"170px"} }),
                  _createElementVNode("col", { style: {"width":"60px"} }),
                  _createElementVNode("col", { style: {"width":"60px"} }),
                  _createElementVNode("col", { style: {"width":"60px"} }),
                  _createElementVNode("col", { style: {"width":"150px"} }),
                  _createElementVNode("col", { style: {"width":"150px"} }),
                  _createElementVNode("col", { style: {"width":"100px"} }),
                  _createElementVNode("col", { style: {"width":"70px"} }),
                  _createElementVNode("col", { style: {"width":"80px"} }),
                  _createElementVNode("col", { style: {"width":"80px"} }),
                  _createElementVNode("col", { style: {"width":"60px"} }),
                  _createElementVNode("col", { style: {"width":"60px"} }),
                  _createElementVNode("col", { style: {"width":"60px"} })
                ], -1)),
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", _hoisted_23, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (($setup.state.checkAll) = $event)),
                        onChange: _cache[23] || (_cache[23] = ($event: any) => ($setup.toggleAll()))
                      }, null, 544), [
                        [_vModelCheckbox, $setup.state.checkAll]
                      ])
                    ]),
                    _cache[44] || (_cache[44] = _createElementVNode("th", null, "번호", -1)),
                    _cache[45] || (_cache[45] = _createElementVNode("th", null, "제목", -1)),
                    _cache[46] || (_cache[46] = _createElementVNode("th", null, "작성일", -1)),
                    _cache[47] || (_cache[47] = _createElementVNode("th", null, "모집인원", -1)),
                    _cache[48] || (_cache[48] = _createElementVNode("th", null, "신청인원", -1)),
                    _cache[49] || (_cache[49] = _createElementVNode("th", null, "선발인원", -1)),
                    _cache[50] || (_cache[50] = _createElementVNode("th", null, "모집기간", -1)),
                    _cache[51] || (_cache[51] = _createElementVNode("th", null, "활동기간", -1)),
                    _cache[52] || (_cache[52] = _createElementVNode("th", null, "신청종료", -1)),
                    _cache[53] || (_cache[53] = _createElementVNode("th", null, "진행상태", -1)),
                    _cache[54] || (_cache[54] = _createElementVNode("th", null, "선발상태", -1)),
                    _cache[55] || (_cache[55] = _createElementVNode("th", null, "신청서 양식", -1)),
                    _cache[56] || (_cache[56] = _createElementVNode("th", null, "선발", -1)),
                    _cache[57] || (_cache[57] = _createElementVNode("th", null, "현황", -1)),
                    _cache[58] || (_cache[58] = _createElementVNode("th", null, "수정", -1))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  ($setup.state.list.length > 0)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.state.list, (item, idx) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: item.idx
                        }, [
                          _createElementVNode("td", _hoisted_24, [
                            _createElementVNode("label", {
                              for: 'chk_main' + item.idx,
                              onClick: _cache[26] || (_cache[26] = _withModifiers(() => {}, ["stop"]))
                            }, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                id: 'chk_main' + item.idx,
                                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (($setup.state.checkedList) = $event)),
                                value: item.idx,
                                onClick: _cache[25] || (_cache[25] = _withModifiers(() => {}, ["stop"]))
                              }, null, 8, _hoisted_26), [
                                [_vModelCheckbox, $setup.state.checkedList]
                              ])
                            ], 8, _hoisted_25)
                          ]),
                          _createElementVNode("td", _hoisted_27, _toDisplayString(($setup.state.page - 1) * $setup.state.size + (idx + 1)), 1),
                          _createElementVNode("td", _hoisted_28, [
                            _createElementVNode("a", {
                              href: $setup.state.userSiteUrl + '/#/activityView/' + item.idx,
                              target: "_blank"
                            }, _toDisplayString(item.title), 9, _hoisted_29)
                          ]),
                          _createElementVNode("td", _hoisted_30, _toDisplayString($setup.CommonUtils.dateFormat(new Date(item.createDate), ".", true)), 1),
                          _createElementVNode("td", _hoisted_31, _toDisplayString(!item.cntApply ? 0 : $setup.CommonUtils.numberFormat(item.cntApply)), 1),
                          _createElementVNode("td", _hoisted_32, _toDisplayString(!item.applyCnt ? 0 : $setup.CommonUtils.numberFormat(item.applyCnt)), 1),
                          _createElementVNode("td", _hoisted_33, _toDisplayString(!item.pickCnt ? 0 : $setup.CommonUtils.numberFormat(item.pickCnt)), 1),
                          _createElementVNode("td", _hoisted_34, [
                            (item.recruitStartDate && item.recruitEndDate)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(_toDisplayString($setup.CommonUtils.dateFormatYY(new Date(item.recruitStartDate), ".")) + " ~ " + _toDisplayString($setup.CommonUtils.dateFormatYY(new Date(item.recruitEndDate), ".")), 1)
                                ], 64))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", _hoisted_35, [
                            (item.activeStartDate && item.activeEndDate)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(_toDisplayString($setup.CommonUtils.dateFormatYY(new Date(item.activeStartDate), ".")) + " ~ " + _toDisplayString($setup.CommonUtils.dateFormatYY(new Date(item.activeEndDate), ".")), 1)
                                ], 64))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", _hoisted_36, _toDisplayString(item.applyDate ? $setup.CommonUtils.dateFormatYY(new Date(item.applyDate), ".") : "-"), 1),
                          _createElementVNode("td", _hoisted_37, _toDisplayString($setup.strState(item.state)), 1),
                          _createElementVNode("td", _hoisted_38, _toDisplayString(item.applyState == 1 ? "완료" : "미완료"), 1),
                          _createElementVNode("td", _hoisted_39, [
                            (item.state === 1)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  type: "button",
                                  class: "table_btn _blue",
                                  onClick: ($event: any) => ($setup.showForm(item.idx))
                                }, "보기", 8, _hoisted_40))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", _hoisted_41, [
                            (item.state > 1 && item.applyState === 0)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  type: "button",
                                  class: "table_btn _blue",
                                  onClick: ($event: any) => ($setup.activityRecruitModal(item.idx))
                                }, "확인", 8, _hoisted_42))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", _hoisted_43, [
                            (item.applyState === 1)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  type: "button",
                                  class: "table_btn _blue",
                                  onClick: ($event: any) => ($setup.activityStateModal(item.idx))
                                }, "보기", 8, _hoisted_44))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", _hoisted_45, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "table_btn _blue",
                              onClick: ($event: any) => ($setup.showModal(item.type, item.idx))
                            }, "수정", 8, _hoisted_46)
                          ])
                        ]))
                      }), 128))
                    : (_openBlock(), _createElementBlock("tr", _hoisted_47, [...(_cache[59] || (_cache[59] = [
                        _createElementVNode("td", { colspan: "15" }, [
                          _createElementVNode("div", {
                            class: "tb_subject",
                            style: {"text-align":"center","width":"100%"}
                          }, "데이터가 없습니다.")
                        ], -1)
                      ]))]))
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        ($setup.state.typeState == 3)
          ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
              _createElementVNode("table", null, [
                _cache[68] || (_cache[68] = _createElementVNode("colgroup", null, [
                  _createElementVNode("col", { style: {"width":"40px"} }),
                  _createElementVNode("col", { style: {"width":"100px"} }),
                  _createElementVNode("col"),
                  _createElementVNode("col", { style: {"width":"120px"} }),
                  _createElementVNode("col", { style: {"width":"120px"} }),
                  _createElementVNode("col", { style: {"width":"170px"} }),
                  _createElementVNode("col", { style: {"width":"170px"} })
                ], -1)),
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", _hoisted_49, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (($setup.state.checkAll) = $event)),
                        onChange: _cache[28] || (_cache[28] = ($event: any) => ($setup.toggleAll()))
                      }, null, 544), [
                        [_vModelCheckbox, $setup.state.checkAll]
                      ])
                    ]),
                    _cache[61] || (_cache[61] = _createElementVNode("th", null, "번호", -1)),
                    _cache[62] || (_cache[62] = _createElementVNode("th", null, "제목", -1)),
                    _cache[63] || (_cache[63] = _createElementVNode("th", null, "조회수", -1)),
                    _cache[64] || (_cache[64] = _createElementVNode("th", null, "댓글수", -1)),
                    _cache[65] || (_cache[65] = _createElementVNode("th", null, "작성자", -1)),
                    _cache[66] || (_cache[66] = _createElementVNode("th", null, "작성일", -1))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  ($setup.state.list.length > 0)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.state.list, (item, idx) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: item.idx
                        }, [
                          _createElementVNode("td", _hoisted_50, [
                            _createElementVNode("label", {
                              for: 'chk_' + item.idx,
                              onClick: _cache[31] || (_cache[31] = _withModifiers(() => {}, ["stop"]))
                            }, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                id: 'chk_' + item.idx,
                                "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (($setup.state.checkedList) = $event)),
                                value: item.idx,
                                onClick: _cache[30] || (_cache[30] = _withModifiers(() => {}, ["stop"]))
                              }, null, 8, _hoisted_52), [
                                [_vModelCheckbox, $setup.state.checkedList]
                              ])
                            ], 8, _hoisted_51)
                          ]),
                          _createElementVNode("td", _hoisted_53, _toDisplayString(($setup.state.page - 1) * $setup.state.size + (idx + 1)), 1),
                          _createElementVNode("td", _hoisted_54, [
                            _createElementVNode("a", {
                              href: $setup.state.userSiteUrl + '/#/suggestView/' + item.idx,
                              target: "_blank"
                            }, _toDisplayString(item.title), 9, _hoisted_55)
                          ]),
                          _createElementVNode("td", _hoisted_56, _toDisplayString(item.viewCnt), 1),
                          _createElementVNode("td", _hoisted_57, _toDisplayString(item.commentCnt), 1),
                          _createElementVNode("td", null, _toDisplayString(item.writer), 1),
                          _createElementVNode("td", _hoisted_58, _toDisplayString($setup.CommonUtils.dateFormat(new Date(item.createDate), ".", true)), 1)
                        ]))
                      }), 128))
                    : (_openBlock(), _createElementBlock("tr", _hoisted_59, [...(_cache[67] || (_cache[67] = [
                        _createElementVNode("td", { colspan: "6" }, [
                          _createElementVNode("div", {
                            class: "tb_subject",
                            style: {"text-align":"center","width":"100%"}
                          }, "데이터가 없습니다.")
                        ], -1)
                      ]))]))
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        ($setup.state.list.length !== 0)
          ? (_openBlock(), _createBlock(_component_PageBtn, {
              key: 2,
              currentPage: $setup.state.page,
              totalLength: $setup.state.totalLength,
              perPage: $setup.state.size,
              data: $setup.state.data,
              onOnPaging: $setup.handlePageChange
            }, null, 8, ["currentPage", "totalLength", "perPage", "data", "onOnPaging"]))
          : _createCommentVNode("", true)
      ])
    ]),
    ($setup.state.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 0,
          type: $setup.state.modalTab,
          title: $setup.state.modalTitle,
          content: $setup.state.modalContent,
          onClose: $setup.closeModal,
          onCallback: $setup.callBackModal
        }, null, 8, ["type", "title", "content", "onClose", "onCallback"]))
      : _createCommentVNode("", true),
    ($setup.state.isShowForm)
      ? (_openBlock(), _createBlock(_component_FormListModal, {
          key: 1,
          idx: $setup.state.idx,
          type: "board",
          onClose: _cache[32] || (_cache[32] = ($event: any) => ($setup.state.isShowForm = false)),
          onCallback: _cache[33] || (_cache[33] = ($event: any) => {
            $setup.state.isShowForm = false;
            $setup.getList();
        })
        }, null, 8, ["idx"]))
      : _createCommentVNode("", true),
    ($setup.state.isActivityShowModal)
      ? (_openBlock(), _createBlock(_component_ActivityModal, {
          key: 2,
          data: $setup.state.activityInfo,
          onClose: _cache[34] || (_cache[34] = ($event: any) => ($setup.state.isActivityShowModal = false)),
          onCallback: _cache[35] || (_cache[35] = ($event: any) => {
            $setup.state.isActivityShowModal = false;
            $setup.getList();
        })
        }, null, 8, ["data"]))
      : _createCommentVNode("", true),
    ($setup.state.isShowActivityStateModal)
      ? (_openBlock(), _createBlock(_component_ActivityStateModal, {
          key: 3,
          idx: $setup.state.itemIdx,
          onClose: _cache[36] || (_cache[36] = ($event: any) => ($setup.state.isShowActivityStateModal = false)),
          onViewSign: $setup.viewSign,
          onExportSign: $setup.exportSign,
          onSaveForMemo: $setup.saveForMemo,
          onExportExcelForActivityApply: $setup.exportExcelForActivityApply
        }, null, 8, ["idx", "onViewSign", "onExportSign", "onSaveForMemo", "onExportExcelForActivityApply"]))
      : _createCommentVNode("", true),
    ($setup.state.isShowActivityRecruitModal)
      ? (_openBlock(), _createBlock(_component_ActivityRecruitModal, {
          key: 4,
          idx: $setup.state.itemIdx,
          onClose: _cache[37] || (_cache[37] = ($event: any) => ($setup.state.isShowActivityRecruitModal = false)),
          onSave: $setup.save,
          onViewSign: $setup.viewSign,
          onExportSign: $setup.exportSign
        }, null, 8, ["idx", "onSave", "onViewSign", "onExportSign"]))
      : _createCommentVNode("", true)
  ], 64))
}